import * as React from "react";
import {
	WithStyles,
	Theme,
	createStyles,
	withStyles,
	List,
	ListItem,
	ListItemText,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell
} from "@material-ui/core";
import { connect } from "react-redux";

import Paper from "@material-ui/core/Paper";

import { StoreState } from "../../reducers/root-reducer";

interface State {
	meals: {
		name: string;
		quantity: number;
	}[];
}

type Props = ReturnType<typeof mapStateToProps> & WithStyles<typeof styles>;

export class PreorderedMealsList extends React.Component<Props> {
	public readonly state: State = {
		meals: []
	}

	public componentDidMount() {
		this.setMealsFromProps(this.props);
	}

	public componentWillReceiveProps(nextProps: Props) {
		this.setMealsFromProps(nextProps);
	}

	public shouldComponentUpdate(_: Props, nextState: State) {
		return this.state.meals !== nextState.meals;
	}

	private setMealsFromProps = (props: Props) => {
		const { reservations, meals } = props;

		const mealIDMap: { [key: string]: string; } =
			meals.reduce((map: { [key: string]: string; }, meal) => {
				map[meal.id] = meal.name;

				return map;
			}, {});

		const combinedMeals: { [key: string]: number } = {};

		reservations.forEach(res => {
			if (res.meals) {
				Object.keys(res.meals).forEach(key => {
					const name = mealIDMap[key];

					combinedMeals[name] = (combinedMeals[name] || 0) + res.meals[key];
				});
			}
		});

		const m = Object.keys(combinedMeals).map(key => ({
			name: key,
			quantity: combinedMeals[key]
		}));

		this.setState({
			meals: m
		});
	}

	public render() {
		const { classes } = this.props;
		const { meals } = this.state;

		if (meals.length === 0) return null;

		return (
			<Paper>
				{/*
				<List>
					{meals.map(meal => (
						<ListItem>
							<ListItemText primary={meal.quantity + "x " + meal.name} />
						</ListItem>
					))}
				</List>
				  */}
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Menge</TableCell>
							<TableCell>Name</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{meals.map(meal => (
							<TableRow key={meal.name}>
								<TableCell>{meal.quantity}</TableCell>
								<TableCell>{meal.name}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	reservations: state.reservations,
	meals: state.settings.meals
});

const styles = (theme: Theme) =>
	createStyles({
	});

export const ConnectedPreorderedMealsList = withStyles(styles)(
	connect(
		mapStateToProps
	)(PreorderedMealsList)
);
